/**
 * Zod-схемы входа команды Skrezo (ADMIN_BACKEND_SPEC §2):
 *   POST /admin/auth/login  body: { login, password }
 */

import {z} from 'zod';

export const TeamLoginRequestSchema = z.object({
  login: z.string().min(9, 'Введите телефон полностью'),
  password: z.string().min(1, 'Введите пароль'),
});

export type TeamLoginRequest = z.infer<typeof TeamLoginRequestSchema>;

export const TeamLoginResponseSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  expiresIn: z.number(),
  /** Временный пароль — сразу на смену пароля, в панель после неё */
  mustChangePassword: z.boolean(),
  user: z.object({
    id: z.string(),
    fullName: z.string().nullable(),
    login: z.string(),
  }),
});

export type TeamLoginResponse = z.infer<typeof TeamLoginResponseSchema>;
